var JS_SWITCHER_SELECTOR = 'card-view-switcher';
var currentView = 'none';
function loadView() {
    var cookie = document.cookie.split(';').find(function (cookie) { return cookie.includes('player_listing_list'); });
    if (cookie) {
        currentView = 'list';
    }
    else {
        currentView = 'card';
    }
}
function initSwitcherButton(switcherButton) {
    if (currentView !== 'none') {
        switcherButton.classList.remove('!hidden');
    }
    if (currentView === 'card') {
        switcherButton.textContent = 'List View';
    }
    else if (currentView === 'list') {
        switcherButton.textContent = 'Card View';
    }
}
function bindClickEvent(switcherButton) {
    switcherButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (currentView === 'list') {
            document.cookie = 'player_listing_list=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
        else {
            document.cookie = "player_listing_list=true; path=/;";
        }
        setTimeout(function () {
            window.location.reload();
        }, 100);
    });
}
export function cardViewSwitcherInit() {
    var switcherButtons = Array.from(document.querySelectorAll("[data-js-selector='".concat(JS_SWITCHER_SELECTOR, "']")));
    if (!switcherButtons.length) {
        return;
    }
    loadView();
    switcherButtons.forEach(function (switcherButton) {
        initSwitcherButton(switcherButton);
        bindClickEvent(switcherButton);
    });
}
